import React from "react";
import { getReceiptFileName } from "./receiptUtils";

export const createOrderReceiptPdf = async (order) => {
  const [{ pdf }, { default: OrderReceiptPdfDocument }] = await Promise.all([
    import("@react-pdf/renderer"),
    import("./OrderReceiptPdfDocument"),
  ]);

  return pdf(<OrderReceiptPdfDocument order={order} />).toBlob();
};

export const downloadOrderReceiptPdf = async (order) => {
  const blob = await createOrderReceiptPdf(order);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = getReceiptFileName(order);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
